import guardsForModel from "./forTBuilderModel";
import { AllPresentationTemplates } from "../../requests/templateBuilder/types";
import makeGuardsForModelSubset from "../makeGuardsForModelSubset";
import { PresentationTemplateGroups } from "../modelGroups/otherModelGroups";

type SchemaKey = keyof typeof guardsForModel;
type CompleteUnion = AllPresentationTemplates;
type Groups = PresentationTemplateGroups;

const criteria = <Key extends SchemaKey>(
  key: SchemaKey,
  presentationTemplate: CompleteUnion
): presentationTemplate is Groups[Key] => {
  const { parentTemplateBuilderModel } = presentationTemplate;
  return guardsForModel[key](parentTemplateBuilderModel);
};

const guardsForSubset = makeGuardsForModelSubset<
  CompleteUnion,
  SchemaKey,
  Groups
>(criteria);

export default guardsForSubset;
